import { render, staticRenderFns } from "./Ppc1.vue?vue&type=template&id=7ac0a32a&scoped=true&"
import script from "./Ppc1.vue?vue&type=script&lang=js&"
export * from "./Ppc1.vue?vue&type=script&lang=js&"
import style0 from "./Ppc1.vue?vue&type=style&index=0&id=7ac0a32a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac0a32a",
  null
  
)

export default component.exports